"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EyeSlash: function() {
        return EyeSlash;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const EyeSlash = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.29289 1.29289C1.68342 0.902369 2.31658 0.902369 2.70711 1.29289L6.66951 5.25529C8.26454 4.45277 10.079 4 12 4C17.1112 4 21.4754 7.20778 22.9499 11.6874C23.0167 11.8905 23.0167 12.1096 22.9499 12.3127C22.2433 14.4594 20.8721 16.3138 19.0765 17.6623L22.7071 21.2929C23.0976 21.6834 23.0976 22.3166 22.7071 22.7071C22.3166 23.0976 21.6834 23.0976 21.2929 22.7071L16.8175 18.2317C16.807 18.2217 16.7967 18.2114 16.7866 18.2008L13.4759 14.8901C13.4675 14.882 13.4592 14.8737 13.4511 14.8653L9.13508 10.5493C9.12667 10.5412 9.11838 10.5329 9.1102 10.5244L5.80021 7.21442C5.78969 7.20436 5.77937 7.19404 5.76925 7.18347L1.29289 2.70711C0.902369 2.31658 0.902369 1.68342 1.29289 1.29289ZM8.17625 6.76204L9.94148 8.52727C10.55 8.19085 11.2535 8 11.9992 8C14.2432 8 16.1431 9.74722 16.1431 12C16.1431 12.7768 15.9136 13.4985 15.5218 14.1076L17.645 16.2308C19.151 15.1691 20.3083 13.6977 20.9405 12C19.6463 8.52552 16.1503 6 12 6C10.6371 6 9.34412 6.27257 8.17625 6.76204ZM14.0371 12.6229C14.1063 12.4259 14.1431 12.2164 14.1431 12C14.1431 10.9391 13.2279 10 11.9992 10C11.8175 10 11.6418 10.021 11.4744 10.0602L14.0371 12.6229ZM4.12786 8.32626C4.56698 8.66121 4.65142 9.28872 4.31647 9.72784C3.78897 10.4194 3.36358 11.1834 3.0595 11.9999C4.35367 15.4745 7.84973 18 12 18C12.4076 18 12.8088 17.9756 13.2021 17.9284C13.7505 17.8626 14.2484 18.2537 14.3142 18.8021C14.38 19.3504 13.9888 19.8483 13.4405 19.9142C12.9682 19.9708 12.4875 20 12 20C6.88883 20 2.52458 16.7922 1.05013 12.3126C0.983289 12.1095 0.98329 11.8904 1.05013 11.6873C1.42955 10.5346 2.00086 9.46587 2.72628 8.51486C3.06123 8.07574 3.68874 7.9913 4.12786 8.32626Z",
        fill: "currentColor"
    })
}), "EyeSlash");
const _default = EyeSlash;
